import { Injectable } from '@angular/core';

@Injectable()
export class SessionManagementService {

  constructor() { }

  getSession() {

    if (!window.sessionStorage) {
      return "00000000-0000-0000-0000-000000000000";
    }

    var session = sessionStorage.getItem("monitoring.session");

    if (!session) {
      session = this.uuidFast();
      sessionStorage.setItem("monitoring.session", session);
    }

    return session;
  }

  // Private array of chars to use
  private CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');

  // A more performant, but slightly bulkier, RFC4122v4 solution.  We boost performance
  // by minimizing calls to random()
  uuidFast() {
    var chars = this.CHARS, uuid = new Array(36), rnd = 0, r;
    for (var i = 0; i < 36; i++) {
      if (i == 8 || i == 13 || i == 18 || i == 23) {
        uuid[i] = '-';
      } else if (i == 14) {
        uuid[i] = '4';
      } else {
        if (rnd <= 0x02) rnd = 0x2000000 + (Math.random() * 0x1000000) | 0;
        r = rnd & 0xf;
        rnd = rnd >> 4;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
    return uuid.join('');
  };

}
